/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantDto } from '../../models/backend-opex-variant-dto';
import { BackendPatchedOpexVariantRequestDto } from '../../models/backend-patched-opex-variant-request-dto';

export interface SalesOpexVariantsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this opex variant.
   */
  id: number;
  body?: BackendPatchedOpexVariantRequestDto;
}

export function salesOpexVariantsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexVariantsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexVariantsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantDto>;
    }),
  );
}

salesOpexVariantsPartialUpdate$FormData.PATH = '/api/sales/opex_variants/{id}/';
